import axios from '../utils/axios';

export default function getProMemberShipInvoiceCreditNotesList(adminId, params, isDownload) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/subscription/invoice/view-invoice-credit-list`, { params, responseType: isDownload ? 'blob' : 'json' })
    .then(res =>{
        if(isDownload) return res;
        return res.data;
    }
    )
};